import "./styles.scss";
import DropdownCard from "components/DropdownCard";
import classNames from "classnames";

import { Link } from "react-router-dom";

const mainClass = "dropdown-menu";

const DropdownMenu = ({ items, closeHandler }) => {
  return (
    <DropdownCard variant="menu">
      <div className={mainClass}>
        <div className={`${mainClass}__wrapper`}>
          {items?.map(({ icon, label, href, action, slug }, index) => {
            const content = (
              <>
                <div
                  className={classNames(`${mainClass}__item__icon`, {
                    [`${mainClass}__item__icon--${slug}`]:!!slug,
                  })}
                >
                  {icon}
                </div>
                {label}
              </>
            );

            const classname = `${mainClass}__item`;

            return !!href ? (
              <Link
                key={index}
                to={href}
                className={classname}
                onClick={closeHandler}
              >
                {content}
              </Link>
            ) : (
              <button
                key={index}
                onClick={() => {
                  action();
                  closeHandler();
                }}
                className={classname}
                type="button"
              >
                {content}
              </button>
            );
          })}
        </div>
      </div>
    </DropdownCard>
  );
};

export default DropdownMenu;
